import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

// safe jwt payload parser (no external deps)
function parseJwt<T = any>(token: string): T | null {
  try {
    if (!token) return null;
    const raw = token.startsWith('Bearer ') ? token.slice(7) : token;
    const parts = raw.split('.');
    if (parts.length < 2) return null;
    let payload = parts[1];
    payload = payload.replace(/-/g, '+').replace(/_/g, '/');
    while (payload.length % 4) payload += '=';
    const json = decodeURIComponent(
      atob(payload)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json) as T;
  } catch {
    return null;
  }
}

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // try auth context first, fall back to local/session storage
  const auth = useAuth();
  const ctxToken = (auth as any)?.token;
  const storedToken =
    ctxToken ||
    localStorage.getItem('token') ||
    localStorage.getItem('authToken') ||
    sessionStorage.getItem('authToken') ||
    '';

  if (!storedToken) return <Navigate to="/login" replace />;

  const payload = parseJwt<{ role?: string; Role?: string }>(storedToken);
  const role = (payload?.role ?? payload?.Role ?? '').toString().toLowerCase();

  return role === 'admin' ? <>{children}</> : <Navigate to="/login" replace />;
};

export default AdminRoute;
